/**
 * Created by Administrador on 10/17/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('users', {
                parent: 'app',
                url: '/users?page&size',
                params: {
                    page: "0",
                    size: "10"
                },
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/user/users.html',
                        controller: 'usersController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['translationHandler', function (translationHandler) {
                        return translationHandler.translateRefresh(['user']);
                    }],
                    users: ['userService', '$stateParams', function(userService, $stateParams){
                        return userService.getUsers($stateParams.page, $stateParams.size, true)
                    }]
                }
            })
            .state('userNew', {
                parent: 'app',
                url: '/user/new',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/user/newUser.html',
                        controller: 'newUserController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['translationHandler', function (translationHandler) {
                        return translationHandler.translateRefresh(['user']);
                    }],
                    branchOffices: ['branchOfficeService', function(branchOfficeService){
                        return branchOfficeService.getBranchOfficeList()
                    }],
                    positionTypes: ['userService', function(userService){
                        return userService.getPositionTypes()
                    }]
                }
            })
            .state('userEdit', {
                parent: 'app',
                url: '/user/:id/edit',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/user/editUser.html',
                        controller: 'editUserController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['translationHandler', function (translationHandler) {
                        return translationHandler.translateRefresh(['user']);
                    }],
                    userId: ['$stateParams', function($stateParams){
                        return $stateParams.id;
                    }],
                    user: ['userService', '$stateParams', function(userService, $stateParams){
                        return userService.getUser($stateParams.id, true)
                    }],
                    branchOffices: ['branchOfficeService', function(branchOfficeService){
                        return branchOfficeService.getBranchOfficeList()
                    }],
                    roles: ['roleService', function(roleService){
                        return roleService.getRoles()
                    }],
                    positionTypes: ['userService', function(userService){
                        return userService.getPositionTypes()
                    }]
                }
            })
            .state('userDelete', {
                parent: 'users',
                url: '/user/:id/delete',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/configGeneral/user/deleteUser.html',
                        controller: 'deleteUserController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            'userId': [function() {
                                return $stateParams.id
                            }],
                            'user': ['userService', function(userService) {
                                return userService.getUser($stateParams.id)
                            }]
                        }
                    }).result.then(function() {
                        $state.go('users', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            .state('associatedBranchOffice', {
                parent: 'app',
                url: '/user/:id/associatedBranchOffice',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/user/associatedBranchOffice.html',
                        controller: 'associatedBranchOfficeCtrl',
                        controllerAs: 'vm',
                        resolve:{
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['user']);
                            }],
                            'branchOffices': ['branchOfficeService', function(branchOfficeService) {
                                return branchOfficeService.getBranchOfficeList(true);
                            }],
                            'user': ['userService','$stateParams', function(userService,$stateParams) {
                                return userService.getUser($stateParams.id, true)
                            }]
                        }
                    }
                }
            });
    }
})();
